import { createSelector } from 'reselect';
import getAutomation from 'automation-ui-canvas/selectors/automationSelectors';
import makeLatestArtifactSelectorCreator from 'redux-request-state/selectors/makeLatestArtifactSelectorCreator';
const getRequestStates = createSelector([getAutomation], automationState => automationState.requestStates);
export const makeLatestArtifactSelector = makeLatestArtifactSelectorCreator(getRequestStates);